// src/utils/serviceWorkerUtils.js

/**
 * Get current queue size
 */
export async function getQueueSize() {
  if (!('serviceWorker' in navigator)) return 0;
  
  try {
    const registration = await navigator.serviceWorker.ready;
    
    return new Promise((resolve) => {
      const messageChannel = new MessageChannel();
      
      messageChannel.port1.onmessage = (event) => {
        resolve(event.data.queueSize || 0);
      };
      
      registration.active.postMessage(
        { type: 'GET_QUEUE_SIZE' },
        [messageChannel.port2]
      );
      
      // Timeout after 1 second
      setTimeout(() => resolve(0), 1000);
    });
  } catch (error) {
    console.error('Error getting queue size:', error);
    return 0;
  }
}

/**
 * Clear all queued sync requests
 */
export async function clearSyncQueue() {
  if (!('serviceWorker' in navigator)) return;
  
  try {
    const registration = await navigator.serviceWorker.ready;
    registration.active.postMessage({ type: 'CLEAR_QUEUE' });
    return true;
  } catch (error) {
    console.error('Error clearing queue:', error);
    return false;
  }
}

/**
 * Force immediate sync
 */
export async function forceSyncNow() {
  if (!('serviceWorker' in navigator)) return;
  
  try {
    const registration = await navigator.serviceWorker.ready;
    registration.active.postMessage({ type: 'FORCE_SYNC' });
    return true;
  } catch (error) {
    console.error('Error forcing sync:', error);
    return false;
  }
}

/**
 * Listen to service worker messages
 */
export function onServiceWorkerMessage(callback) {
  if (!('serviceWorker' in navigator)) return () => {};
  
  const handler = (event) => {
    if (event.data && event.data.type) {
      callback(event.data);
    }
  };
  
  navigator.serviceWorker.addEventListener('message', handler);
  
  // Return cleanup function
  return () => {
    navigator.serviceWorker.removeEventListener('message', handler);
  };
}

/**
 * Unregister service worker completely (nuclear option)
 */
export async function unregisterServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      await registration.unregister();
    }
    
    // Also clear caches
    const cacheNames = await caches.keys();
    await Promise.all(
      cacheNames.map(cacheName => caches.delete(cacheName))
    );
    
    console.log('Service worker and caches cleared');
    return true;
  } catch (error) {
    console.error('Error unregistering service worker:', error);
    return false;
  }
}